import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../auth-guard.service';
import { ListaComponent } from './lista/lista.component';
import { AlumnoComponent } from './formulario/formulario.component';
import { RevalidacionComponent } from './revalidacion/revalidacion.component';
import { RepeticionComponent } from './repeticion/repeticion.component';

import { ReporteAlumnoComponent } from './reporte/reporte-alumno.component';
import { OperacionComponent } from './operacion/operacion.component';
import { VerComponent } from './ver/ver.component';

const routes: Routes = [
  {
    path: 'control-escolar', redirectTo: '/control-escolar/alumno/lista', pathMatch: 'full'
  },
  {
    path: 'control-escolar/alumno',
    children: [
      { path: 'lista', component: ListaComponent },
      { path: 'nuevo', component: AlumnoComponent },
      { path: 'editar/:id', component: AlumnoComponent },
      { path: 'ver/:id', component: VerComponent },

    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'control-escolar/revalidacion',
    children: [
       { path: 'nuevo', component: RevalidacionComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'control-escolar/repeticion',
    children: [
       { path: 'nuevo', component: RepeticionComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'control-escolar/alumno-operacion',
    children: [
      { path: 'reporte', component: ReporteAlumnoComponent },
      { path: 'operacion', component: OperacionComponent },
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AlumnoRoutingModule { }

